import { useQuery } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import queryFn from "ApiLayer/Properties/queryProperties";
import { QUERY_STALE_TIME } from "utils/constants";

export const useProperties = () => {
    const accessToken = useAccessToken();
    return useQuery({
        queryKey: ["properties"],
        queryFn: async () => queryFn(accessToken),
        staleTime: QUERY_STALE_TIME,
    });
};
